export default __webpack_public_path__ + "static/logo-marriott-international-5d0e2b161b965221bfc2f1f31cda540d.png";